import React from 'react';
import './reduction.scss';

const GenStyles = () => <React.Fragment></React.Fragment>;

export default GenStyles;
